/** @format */

import React, { useState, useEffect, useRef } from "react";
import heic2any from "heic2any";
import EXIF from "exif-js";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.js";
import "bootstrap-icons/font/bootstrap-icons.css";
import "../../css/Report-TH.css";

import { Modal } from "bootstrap";
import html2canvas from "html2canvas";
import { toPng } from "html-to-image";
import * as funcAll from "../../util/funcAll";

import DropdownOrg from "../menu/DropdownOrg";
import DropdownProblemType from "../menu/DropdownProblemType";
import DropdownWaterLevel from "../menu/DropdownWaterLevel";
import DropdownTimeFlood from "../menu/DropdownTimeFlood";
import PDPA from "./PDPA-EN";

import noImg from "../../assets/no_select.png";
import save from "../../assets/save-icon.png";
import Logo_Traffy from "../../assets/traffy-icon.png";
import Fondue_App_Icon from "../../assets/Fondue_App_Icon.png";
/////////////   Redux  //////////////
import { saveDataLatLon } from "../store/MapPositionSlice";
import { savePageRoute } from "../store/RouteSlice";
import { saveDetailReport } from "../store/DetailReportSlice";

import { useSelector, useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import SecureStorage from "react-secure-storage";

import { reactLocalStorage } from "reactjs-localstorage";

export default function ReportEN(props) {
  const navigate = useNavigate();
  const detailReportStorage = sessionStorage.getItem("detailReport");
  const globalData = useSelector((state) => ({ ...state }));
  const dispatch = useDispatch();

  const [detailReport, setDetailReport] = useState("");
  const [imgReport, setImgReport] = useState(noImg);

  const [listOrganization, setListOrganization] = useState([]);
  const [selectedOrganization, setSelectedOrganization] = useState(null);

  const [listProblemTypeAll, setListProblemTypeAll] = useState([]);
  const [selectedProblemType, setSelectedProblemType] = useState([]);

  const [listWaterLevel, setListWaterLevel] = useState([]);
  const [selectedWaterLevel, setSelectedWaterLevel] = useState([]);

  const [listTimeFlood, setListTimeFlood] = useState([]);
  const [selectedTimeFlood, setSelectedTimeFlood] = useState([]);

  const inputFile = useRef(null);

  const [alert_header, setAlertHeader] = useState(); //หัวข้อ alert
  const [alert_content, setAlertContent] = useState(); //รายละเอียก alert
  const [alert_description, setAlertDescription] = useState(); //รายละเอียก alert
  const modal_alert_ref = useRef(); //สำหรับ alert
  const [modal_alert_close, setModalAlertClose] = useState(null); //สำหรับ alert

  const modal_loading_ref = useRef();
  const [modal_loading_close, setModalLoadingClose] = useState(null);

  const modal_preview_ref = useRef(); //สำหรับ preview ก่อนแจ้ง
  const [modal_preview_close, setModalPreviewClose] = useState(null); //สำหรับ alert

  const modal_finish_card_ref = useRef(); //สำหรับ finish card หลังแจ้ง
  const [modal_finish_card_close, setModalFinishCardClose] = useState(null); //สำหรับ alert

  const exportRef = useRef(null);
  const shareButton = useRef(null);

  const [ip, setIP] = useState("");

  const [resTicketId, setResTicketId] = useState("");
  const [resPassword, setResPassword] = useState("");

  const [previewBtnDisabled, setPreviewBtnDisabled] = useState(false);

  const [update_end, setUpdateEnd] = useState("");
  const [update_enderror, setUpdateEndError] = useState("");

  const [latPhoto, setLatPhoto] = useState(null);
  const [lngPhoto, setLngPhoto] = useState(null);

  const alert_fail = (
    <span class="material-icons text-danger post-alert-icon my-3">cancel</span>
  );

  useEffect(() => {
    setTimeout(() => {
      window.scrollTo(0, 0);
    }, 100);

    getIP();
    navigator.geolocation.getCurrentPosition(showPosition);
    // getLocation();
  }, []);

  const getIP = async () => {
    funcAll.getIpAddress().then((res) => {
      if (res["status"] === "success") {
        setIP(res["results"].ip_addr);
      } else {
      }
    });
  };

  useEffect(() => {
    if (update_end != undefined && update_end != "") {
      modalHide(modal_loading_close);
      setTimeout(() => {
        modalShow(modal_finish_card_ref, setModalFinishCardClose);
      }, 500);
    }
  }, [update_end]);

  useEffect(() => {
    if (update_enderror != undefined && update_enderror != "") {
      modalHide(modal_loading_close);
    }
  }, [update_enderror]);

  const showPosition = async (position) => {
    let current_coors = {
      lng: position.coords.longitude,
      lat: position.coords.latitude,
    };

    await dispatch(saveDataLatLon(current_coors));
  };

  const handleBtnAlertClose = async () => {
    modalHide(modal_alert_close);
  };

  const handlePreviewClose = async () => {
    modalHide(modal_preview_close);
  };

  const handleFinishCardClose = async (ticket, pass, exportElement) => {
    DownloadTicketCard(ticket, pass, exportElement);
  };

  const modalShow = (mRef, setModals) => {
    const modal = new Modal(mRef.current, { keyboard: false });
    setModals(modal);
    modal.show();
  };

  const modalHide = (modal_hide) => {
    modal_hide.hide();
  };

  const onChangePicture = async (e) => {
    const file = e.target.files[0];

    if (file) {
      const fileName = file.name;
      const fileExtension = fileName.split(".").pop().toLowerCase(); // แยกนามสกุลออกมาเป็นตัวพิมพ์เล็ก
      // console.log("File Extension:", fileExtension); // แสดงนามสกุลไฟล์ใน console

      try {
        // ตรวจสอบว่าเป็นไฟล์ HEIC
        if (fileExtension === "heic" || fileExtension === "heif") {
          const convertedBlob = await heic2any({
            blob: file,
            toType: "image/jpeg",
            quality: 0.7,
          });

          // อ่านข้อมูลจากไฟล์ที่แปลงแล้ว
          const reader = new FileReader();
          reader.onload = () => {
            if (reader.result) {
              console.log(reader.result);
              setImgReport(reader.result); // ตั้งค่าภาพที่แปลงเพื่อแสดง
              processImage(reader.result); // ประมวลผลภาพ
            } else {
              console.error("Reader result is empty");
            }
          };
          reader.readAsDataURL(convertedBlob); // อ่านไฟล์ที่แปลงแล้ว
        } else {
          // ถ้าไม่ใช่ไฟล์ HEIC ก็อ่านไฟล์ปกติ
          const reader = new FileReader();
          reader.onload = () => {
            if (reader.result) {
              setImgReport(reader.result); // ตั้งค่าภาพ
              processImage(reader.result); // ประมวลผลภาพ
            } else {
              console.error("Reader result is empty");
            }
          };
          reader.readAsDataURL(file);
        }
      } catch (error) {
        console.error("Error converting HEIC file:", error);
      }
    }
  };

  // ฟังก์ชันประมวลผลภาพ
  const processImage = (imageSrc) => {
    const img = new Image();
    img.src = imageSrc;
    img.onload = () => {
      EXIF.getData(img, function () {
        const exifData = EXIF.getAllTags(this);
        // console.log("EXIF Data:", exifData);

        // ดึงข้อมูล GPS latitude และ longitude
        const lat = EXIF.getTag(this, "GPSLatitude");
        const lng = EXIF.getTag(this, "GPSLongitude");
        const latRef = EXIF.getTag(this, "GPSLatitudeRef");
        const lngRef = EXIF.getTag(this, "GPSLongitudeRef");

        if (lat && lng) {
          const latitude = convertDMSToDD(lat[0], lat[1], lat[2], latRef);
          const longitude = convertDMSToDD(lng[0], lng[1], lng[2], lngRef);

          setLatPhoto(latitude);
          setLngPhoto(longitude);
        } else {
          console.log("No GPS data available");
        }
      });
    };
  };

  const convertDMSToDD = (degrees, minutes, seconds, direction) => {
    let dd = degrees + minutes / 60 + seconds / 3600;
    if (direction === "S" || direction === "W") {
      dd = dd * -1;
    }
    return dd;
  };

  const handleClickUploadImg = (event) => {
    if (inputFile.current) {
      inputFile.current.click();
    } else {
      console.error("inputFile.current is null");
    }
  };

  const setAlert = async (header_text, icon, description) => {
    setAlertHeader(header_text);
    setAlertContent(icon);
    setAlertDescription(description);
    modalShow(modal_alert_ref, setModalAlertClose);
  };

  const view_Finish_Card = (e) => {
    setPreviewBtnDisabled(false);
    // modalHide(modal_preview_close);
    setTimeout(() => {
      modalShow(modal_loading_ref, setModalLoadingClose);
    }, 500);

    funcAll
      .sendDataEN(
        detailReport,
        imgReport,
        latPhoto ? latPhoto : globalData.mapPosition.current_coors.lat,
        lngPhoto ? lngPhoto : globalData.mapPosition.current_coors.lng,
        "en",
      )
      .then((res) => {
        if (res["status"] === "success") {
          setTimeout(() => {
            setUpdateEnd(Date.now());
          }, 500);
          setResTicketId(res["results"].ticket_id);
          setResPassword(res["results"].password);
          let authorize = {
            ticket_report: res["results"].ticket_id,
            password_report: res["results"].password,
          };
          SecureStorage.setItem("authorization", authorize);
        } else if (res["status"] === "fail") {
          setTimeout(() => {
            setUpdateEndError(Date.now());
          }, 500);

          setTimeout(() => {
            setAlert("Fail", alert_fail, res["message"]);
          }, 1500);
        }
      });
  };

  const DownloadTicketCard = (ticket, pass, domElement) => {
    if (domElement === null) {
      return;
    }

    toPng(domElement)
      .then((dataUrl) => {
        const link = document.createElement("a");
        link.href = dataUrl;
        link.download = "myCase.png";
        link.click();

        modalHide(modal_finish_card_close);

        let authorize = {
          ticket_report: ticket,
          password_report: pass,
        };

        sessionStorage.setItem("authorization", JSON.stringify(authorize));
        setTimeout(() => {
          navigate("/track");
        }, 1000);
      })
      .catch((err) => {
        console.log("Error while generating image:", err);

        modalHide(modal_finish_card_close);

        let authorize = {
          ticket_report: ticket,
          password_report: pass,
        };

        sessionStorage.setItem("authorization", JSON.stringify(authorize));
        setTimeout(() => {
          navigate("/track");
        }, 1000);
      });
  };

  const view_Preview = (e) => {
    if (detailReport.length < 1) {
      setTimeout(() => {
        setAlert(
          "Failed",
          alert_fail,
          "Kindly provide details regarding the issue you wish to report or propose a solution relevant to your concern.",
        );
      }, 1000);
    } else if (detailReport.length >= 1 && detailReport.length < 5) {
      setTimeout(() => {
        setAlert("Failed", alert_fail, "Too short details.");
      }, 1000);
    } else if (imgReport == noImg) {
      setAlert("Failed", alert_fail, "Please attach an image");
    } else if (
      Object.keys(globalData.mapPosition.current_coors).length === 0 &&
      !latPhoto
    ) {
      setAlert(
        "Failed",
        alert_fail,
        "Please allow access to your current location to report issues",
      );
    } else {
      view_Finish_Card();
      // modalShow(modal_preview_ref, setModalPreviewClose);
      // modalShow(modal_finish_card_ref, setModalFinishCardClose);
    }
  };

  return (
    <>
      <div className="container-reportDesktop">
        {/* <div className="ip-address">
          <p>{ip}</p>
        </div> */}
        <span>
          <p className="title">Describe Your Issue</p>
          <p className="star">*</p>
        </span>

        <div className="container-detail-img">
          <textarea
            required
            type="text"
            minLength={5}
            value={detailReport}
            onChange={(e) => setDetailReport(e.target.value)}
            placeholder="Kindly provide details regarding the issue you wish to report or propose a solution relevant to your concern."
          />

          <div
            className="area-img-report-desktop"
            onClick={() => handleClickUploadImg()}>
            <img
              className={`img-report ${imgReport !== noImg ? "have-img" : ""}`}
              src={imgReport}
            />
            <input
              type="file"
              id="file"
              required
              onChange={onChangePicture}
              ref={inputFile}
              accept="image/*"
              style={{ display: "none" }}
            />

            {imgReport === noImg ? (
              <>
                <span>
                  <p
                    className="titleMd"
                    style={{
                      color: "#34b70d",
                      textAlign: "center",
                      padding: "0 0.5rem",
                    }}>
                    Kindly attach an image depicting the problem to this
                    communication.
                  </p>
                </span>
              </>
            ) : null}
          </div>
        </div>

        <div>
          <button
            className="btn-report"
            style={{ marginTop: "2rem", width: "40%" }}
            onClick={view_Preview}>
            <p>Submit</p>
          </button>

          <PDPA />
        </div>
      </div>

      {/* ******* ส่วนของ Alert ************* */}
      <div className="modal fade" ref={modal_alert_ref}>
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content bg-transparent border-0">
            <div className="modal-body text-center">
              <div className="d-flex justify-content-center">
                <div className="card post-alert-box rounded-4">
                  <div className="card-body">
                    <p className="card-text p-0 m-0">{alert_content}</p>
                    <h4 className="txt-title-alert">{alert_header}</h4>
                    <h6 className="txt-detail-alert">{alert_description}</h6>
                    <button
                      type="button"
                      className="btn-alert"
                      onClick={handleBtnAlertClose}>
                      <p>OK</p>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* ******* ส่วนของ Alert ************* */}

      {/* กำลังดำเนินการแจ้งเรื่อง */}
      <div
        className="modal fade"
        ref={modal_loading_ref}
        id="loadingReport"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
        tabindex="-1"
        aria-labelledby="staticBackdropLabel"
        aria-hidden="true">
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content bg-transparent border-0">
            <div className="modal-body text-center">
              <div className="d-flex justify-content-center">
                <span className="spinner-border text-white" role="status">
                  <span className="visually-hidden">Loading...</span>
                </span>
                <h4 className="text-white ps-2">Please wait a moment...</h4>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* กำลังดำเนินการแจ้งเรื่อง */}

      {/* ******* ส่วนของ popup finish card ************* */}
      <div class="modal fade" ref={modal_finish_card_ref}>
        <div class="modal-dialog modal-dialog-centered modal-dialog-custom">
          <div class="modal-content modal-content-finish-card">
            <div className="parent" ref={exportRef} id="finish-card">
              <div class="container-detail-finish-card2">
                <div className="container-preview-img-report mt-2">
                  <img src={imgReport}></img>
                </div>

                <div
                  style={{
                    width: "100%",
                    height: "auto",
                    padding: "0.2rem 0.5rem",
                    backgroundColor: "#E6E0E9",
                    display: "flex",
                    flexDirection: "column",
                    gap: "0.1rem",
                    borderBottom: "2px solid #65558F",
                    marginTop: "0.5rem",
                  }}>
                  <p style={{ fontSize: "13px" }}>Ticket ID</p>
                  <p style={{ fontWeight: "600" }}>{resTicketId}</p>
                </div>
                <div
                  style={{
                    width: "100%",
                    height: "auto",
                    padding: "0.2rem 0.5rem",
                    backgroundColor: "#E6E0E9",
                    display: "flex",
                    flexDirection: "column",
                    gap: "0.1rem",
                    borderBottom: "2px solid #65558F",
                    marginTop: "0.5rem",
                  }}>
                  <p style={{ fontSize: "13px" }}>Pin</p>
                  <p style={{ fontWeight: "600" }}>{resPassword}</p>
                </div>
                <div
                  style={{
                    width: "100%",
                    height: "auto",
                    padding: "0.5rem 1rem",
                    backgroundColor: "#FEF7FF",
                    alignItems: "center",
                    justifyContent: "center",
                    marginTop: "0.5rem",
                  }}>
                  <p
                    style={{
                      fontSize: "16px",
                      fontWeight: "600",
                      color: "#e32715",
                    }}>
                    Please ensure that you save this image
                  </p>
                  <p
                    style={{
                      fontSize: "16px",
                      fontWeight: "600",
                      color: "#e32715",
                    }}>
                    It will be necessary for tracking the progress.
                  </p>
                </div>
              </div>
            </div>

            <div
              className="container-btn-finish-card"
              style={{ marginTop: "0.5rem" }}>
              <div
                className="btn-finish-card"
                onClick={() =>
                  handleFinishCardClose(
                    resTicketId,
                    resPassword,
                    exportRef.current,
                  )
                }>
                <p>Saved, Go to Track</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* ******* ส่วนของ popup finish card ************* */}
    </>
  );
}
